export default (
    lRef,
    rRef
) => ((lRef && lRef[0] === '/' ? '' : '/') + lRef) === ((rRef && rRef[0] === '/' ? '' : '/') + rRef);
